








































































































































import { formatDate } from '@/utils/helpers'
import { defineComponent, reactive } from '@vue/composition-api'
import type { Header } from '@/components/composables/useDataTable/types'
import { useDataTable } from '@/components/composables/useDataTable'
import DeleteButton from '@/components/buttons/DeleteButton.vue'
import UserStatusChip from '@/views/User/partials/UserStatusChip.vue'
import UserService from '@/services/user'
import CreateButton from '@/components/buttons/CreateButton.vue'
import EditButton from '@/components/buttons/EditButton.vue'
import ShowButton from '@/components/buttons/ShowButton.vue'
import UsersSearchFilters from '@/views/User/partials/UsersSearchFIlters.vue'
import { StatisticsDTO } from '@/services/user/types'
import StatCard from '@/components/Stats/StatCard.vue'

export default defineComponent({
  setup() {
    const searchParams = reactive({ filters: { status: undefined, roleId: undefined } })
    const { items, totalRecords, loading, pagination, search, query, pages, fetchData } = useDataTable(
      UserService,
      searchParams,
    )

    return {
      items,
      totalRecords,
      loading,
      pagination,
      search,
      query,
      pages,
      fetchData,
      formatDate,
      UserService,
      searchParams,
    }
  },
  name: 'UsersList',
  components: { UsersSearchFilters, ShowButton, EditButton, CreateButton, UserStatusChip, DeleteButton, StatCard },
  data(): { statistics: StatisticsDTO; statsLoading: boolean; filtersExpanded: boolean } {
    return {
      statistics: {
        totalRecords: 0,
        totalActive: 0,
        totalPending: 0,
        totalInactive: 0,
      },
      statsLoading: true,
      filtersExpanded: false,
    }
  },
  computed: {
    activeFilterCount(): number {
      const f = this.searchParams.filters as { status?: unknown[]; roleId?: unknown[] }
      let n = 0
      if (Array.isArray(f.status) && f.status.length) n += f.status.length
      if (Array.isArray(f.roleId) && f.roleId.length) n += f.roleId.length
      return n
    },
    headers(): Array<Header> {
      return [
        { value: 'fullName', text: this.$t('fullName'), sortable: true },
        { value: 'email', text: this.$t('email'), sortable: true },
        { value: 'phone', text: this.$t('phone'), sortable: true },
        { value: 'role', text: this.$t('role'), sortable: true },
        { value: 'status', text: this.$t('status'), sortable: true },
        { value: 'actions', text: this.$t('actions'), sortable: false, align: 'end' },
      ]
    },
  },
  methods: {
    async fetchStatistics() {
      this.statsLoading = true
      const { data } = await UserService.statistics()
      this.statistics = data.data
      this.statsLoading = false
    },
  },
  watch: {
    totalRecords: function () {
      this.fetchStatistics()
    },
  },
})
